
import {defineComponent} from "vue";

export default defineComponent({
  name: "ShareButtons",
  props: {
    text: {
      type: String,
      default: "",
    }
  },
  setup(props) {
    const share = (a_Platform: string) => {
      let l_ShareUrl;
      const l_SiteUrl = "http://gehobenesdeutsch.de/web/index.html#home"
      switch (a_Platform) {
        case 'twitter':
          l_ShareUrl = 'http://twitter.com/share';
          l_ShareUrl += `?url=${l_SiteUrl}`;
          l_ShareUrl += `&text=${props.text}`;
          break;
        case 'facebook':
          l_ShareUrl = 'https://facebook.com/sharer.php?display=popup';
          l_ShareUrl += `&u=${l_SiteUrl}`;
          l_ShareUrl += `&quote=${props.text}`;
          break;
        case 'whatsapp':
          l_ShareUrl = 'whatsapp://send?text=';
            l_ShareUrl += `${props.text} `;
            l_ShareUrl += `${l_SiteUrl}`;
          window.open( l_ShareUrl);
          return;
        case 'mail':
          const l_Subject= "Interesting Information";
          let l_Body = `${props.text}\r\n\r\n<`;
          l_Body += l_SiteUrl;
          l_Body += ">";
          l_ShareUrl = "mailto:?subject=";
          l_ShareUrl += encodeURIComponent(l_Subject);
          l_ShareUrl += "&body=";
          l_ShareUrl += encodeURIComponent(l_Body);
          window.open( l_ShareUrl);
          return;
        default:
          l_ShareUrl = "";
      }
      if(l_ShareUrl){
        window.open( l_ShareUrl , 'popup', "width=600px, height=1000px");
      }


    }

    return {
      share,
    }
  }
})
